var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOpportunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1257 2.08301H9.87565C9.46678 2.08301 9.07465 2.24543 8.78553 2.53455C8.49641 2.82367 8.33398 3.2158 8.33398 3.62467V6.70801C8.33398 7.63301 8.95065 8.24967 9.87565 8.24967H19.1257C20.0507 8.24967 20.6673 7.63301 20.6673 6.70801V3.62467C20.6673 2.69967 20.0507 2.08301 19.1257 2.08301Z",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 5.16602H5.25033C4.43257 5.16602 3.64832 5.49087 3.07008 6.0691C2.49184 6.64734 2.16699 7.4316 2.16699 8.24935V29.8327C2.16699 30.6504 2.49184 31.4347 3.07008 32.0129C3.64832 32.5912 4.43257 32.916 5.25033 32.916H23.7503C24.5681 32.916 25.3523 32.5912 25.9306 32.0129C26.5088 31.4347 26.8337 30.6504 26.8337 29.8327M20.667 5.16602H23.7503C24.5681 5.16602 25.3523 5.49087 25.9306 6.0691C26.5088 6.64734 26.8337 7.4316 26.8337 8.24935V11.3327M12.9587 20.5827H28.3753",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.209 14.416L28.3757 20.5827L22.209 26.7493",
    stroke: "#367FFF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpportunity);
export default __webpack_public_path__ + "static/media/icon-opportunity.0e873f4f91c2c8fbde6a76b03163da8c.svg";
export { ForwardRef as ReactComponent };